// Defaults applied when the user creates a new text object from the editor toolbar.
export const NEW_TEXT_CONTENT = 'Texto Editable';
export const NEW_TEXT_WIDTH = 250;
